import { createGlobalStyle, css } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    ${({ theme }) =>
      Object.keys(theme.fonts).map((k) => {
        const currentFont = theme.fonts[k];

        return css`
          @font-face {
            font-family: '${currentFont.lighter.name}';
            src: url(${currentFont.lighter.file});
            font-weight: lighter;
            font-display: swap;
          }

          @font-face {
            font-family: '${currentFont.normal.name}';
            src: url(${currentFont.normal.file});
            font-weight: normal;
            font-display: swap;
          }

          @font-face {
            font-family: '${currentFont.bold.name}';
            src: url(${currentFont.bold.file});
            font-weight: bold;
            font-display: swap;
          }
        `;
      })}
    ${({ theme }) =>
      theme.extraProps.idRoot &&
      css`
        #${theme.extraProps.idRoot} {
          * {
            box-sizing: border-box;
          }
        }
      `}
`;

export default GlobalStyle;
